// extracted by mini-css-extract-plugin
export default {"selected":"f83f0cbbff","un":"_2ec887c139"};